import { WorkItemContext as L, HostContext as se, setVersionInfo as fe } from "@buzzeasy/shared-frontend-utilities";
import { jsx as n, jsxs as p, Fragment as ye } from "react/jsx-runtime";
import { Fragment as Te, createContext as Ce, useContext as v, useState as g, useMemo as w, useCallback as V, useEffect as R } from "react";
import W, { styled as A, css as ke, ThemeProvider as ve } from "styled-components";
import { List as B, Typography as ce, Badge as Se, Tooltip as $, Avatar as ne, Spin as _, theme as G, Divider as le, Space as xe, Tag as Ie, Tabs as we, ConfigProvider as Ne } from "antd";
import { useTranslation as P, initReactI18next as Pe, I18nextProvider as $e } from "react-i18next";
import { CustomerServiceOutlined as Ae, InboxOutlined as De, MessageOutlined as Ee, UserOutlined as ae, MailOutlined as Z, PhoneOutlined as X, MobileOutlined as Me, SwitcherOutlined as Le } from "@ant-design/icons";
import Be from "antd/es/select";
import { useDebounce as q } from "use-debounce";
import { fetchBaseQuery as qe, createApi as O } from "@reduxjs/toolkit/query/react";
import { createSlice as Oe, configureStore as ze } from "@reduxjs/toolkit";
import Qe from "antd/es/input/Search";
import ue from "react-infinite-scroll-component";
import Ke from "i18next";
import { Provider as Fe } from "react-redux";
import je from "jwt-decode";
const Ue = A.div`
  height: 100%;
  padding: 0 ${(e) => e.theme.paddingSM}px;
`, He = ({ children: e }) => /* @__PURE__ */ n(Ue, { children: e }), Re = {
  apiBaseUrl: "",
  token: "",
  agentId: ""
}, Q = Oe({
  name: "configuration",
  initialState: Re,
  reducers: {}
});
function Xe(e, { getState: t }) {
  const a = t().configuration.token;
  return e.set("authorization", `Bearer ${a}`), e;
}
function z(e) {
  return async (t, a, o) => {
    const { apiBaseUrl: i } = a.getState().configuration;
    return qe({ baseUrl: i + e, prepareHeaders: Xe })(t, a, o);
  };
}
const K = O({
  reducerPath: "blender",
  tagTypes: [],
  baseQuery: z("/blender"),
  endpoints: (e) => ({
    listAgents: e.query({
      queryFn: async (t, a, o, i) => {
        const r = await i(`/agents?businessUnitId=${t ?? ""}`);
        if (r.error)
          return r;
        const s = a.getState()[Q.name].agentId;
        return { data: r.data.filter((b) => b.id !== s), meta: r.meta };
      }
    })
  })
}), {
  useListAgentsQuery: Ve
} = K;
function We(e, t) {
  switch (e) {
    case "Idle":
      return t("agentStatus.available");
    case "Break":
      return t("agentStatus.onBreak");
    case "Busy":
    case "PendingBreak":
    case "PendingLogout":
      return t("agentStatus.busy");
    case "LoggedOut":
    case "Offline":
    case "Unknown":
      return t("agentStatus.loggedOut");
    default:
      return t("agentStatus.unknown");
  }
}
function oe(e, t) {
  switch (t) {
    case "Idle":
      return e.colorSuccess;
    case "Break":
      return e.colorWarning;
    case "Busy":
    case "PendingBreak":
    case "PendingLogout":
      return e.colorError;
    default:
      return "#8a8886";
  }
}
function _e(e) {
  switch (e) {
    case "chat":
      return /* @__PURE__ */ n(Ee, {});
    case "email":
      return /* @__PURE__ */ n(De, {});
    case "voice":
      return /* @__PURE__ */ n(Ae, {});
  }
}
function Ge(e, t) {
  (e.key === "Enter" || e.code === "Space") && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.metaKey && t(e);
}
function Ze(e) {
  return {
    tabIndex: 0,
    onClick: e,
    onKeyDown: (t) => Ge(t, e)
  };
}
const { Text: ie } = ce, Je = W(B.Item)`
  && {
    cursor: pointer;
    position: relative;
    padding: ${(e) => e.theme.paddingXXS}px;

    .ant-list-item-meta {
      align-items: center;

      .ant-list-item-meta-title, .ant-list-item-meta-description {
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 0;
      }

      .ant-list-item-meta-description {
        color: ${(e) => e.theme.colorTextSecondary};
      }
    }
    
    transition: all ${(e) => e.theme.motionDurationMid} ${(e) => e.theme.motionEaseInOut};

    &:hover {
      background-color: ${(e) => e.theme.colorBgTextHover};
    }

    &:focus-visible {
      outline: ${(e) => e.theme.lineWidthFocus}px ${(e) => e.theme.lineType} ${(e) => e.theme.colorPrimaryBorder};
      outline-offset: -${(e) => e.theme.lineWidthFocus}px;
      transition: outline-offset 0s, outline 0s;
    }
  }
`, Ye = W.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  padding: ${(e) => e.theme.paddingXXS}px ${(e) => e.theme.paddingXS}px;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: ${(e) => e.theme.paddingXS}px;

  background: linear-gradient(90deg, transparent 0%, ${(e) => e.theme.colorPrimaryBgHover} 100%);

  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  ${(e) => e.$active && ke`
    opacity: 1;
    visibility: visible;

    > * {
      pointer-events: all;
    }
  `}

  transition: all ${(e) => e.theme.motionDurationMid} ${(e) => e.theme.motionEaseInOut};
`;
function de({ active: e, onActivate: t, avatar: a, title: o, description: i, actions: r }) {
  return /* @__PURE__ */ p(Je, { $active: e, ...Ze(t), children: [
    /* @__PURE__ */ n(
      B.Item.Meta,
      {
        avatar: a,
        title: /* @__PURE__ */ n(ie, { ellipsis: { tooltip: o }, children: o }),
        description: i && /* @__PURE__ */ n(ie, { ellipsis: { tooltip: i }, children: i })
      }
    ),
    /* @__PURE__ */ n(Ye, { $active: e, children: r == null ? void 0 : r.map((s, c) => /* @__PURE__ */ n(Te, { children: s }, c)) })
  ] });
}
const { Text: et } = ce, tt = A(Se).attrs((e) => ({ dot: !0, offset: [-e.theme.sizeXXS, e.theme.sizeXXS] }))`
  .ant-badge-dot {
    width: ${(e) => e.theme.sizeXS}px;
    height: ${(e) => e.theme.sizeXS}px;

    background: ${(e) => oe(e.theme, e.status)};
    box-shadow: 0 0 0 1px ${(e) => oe(e.theme, e.status)};
  }
`;
function J({ status: e, profileImageUrl: t, ...a }) {
  const { t: o } = P(), i = e ? /* @__PURE__ */ n($, { title: We(e, o), children: /* @__PURE__ */ n(tt, { status: e, children: /* @__PURE__ */ n(ne, { size: "large", icon: t ? /* @__PURE__ */ n("img", { src: t, alt: o("persona.profilePicture") }) : /* @__PURE__ */ n(ae, {}), "aria-label": o("persona.profilePicture") }) }) }) : /* @__PURE__ */ n(ne, { size: "large", icon: t ? /* @__PURE__ */ n("img", { src: t, alt: o("persona.profilePicture") }) : /* @__PURE__ */ n(ae, {}), "aria-label": o("persona.profilePicture") });
  return /* @__PURE__ */ n(
    de,
    {
      ...a,
      avatar: i
    }
  );
}
const nt = A(et)`
  color: inherit;

  white-space: pre-wrap;
  overflow: none;
  text-overflow: ellipsis;

  .anticon {
    color: ${(e) => e.theme.colorTextTertiary};
  }

  .df-detail {
    white-space: nowrap;
  }
`;
function Y({ children: e }) {
  return /* @__PURE__ */ n(nt, { children: e });
}
const ee = ({ placeholder: e, searchText: t, onSearchTextChange: a, loading: o }) => /* @__PURE__ */ n(
  Qe,
  {
    loading: o,
    allowClear: !0,
    placeholder: e,
    value: t,
    onChange: (i) => a(i.target.value),
    onSearch: a
  }
), me = A.div`
  min-height: 0px;
  max-height: 100%;

  display: flex;
  flex-direction: column;
  gap: ${(e) => e.theme.paddingXXS}px;
`, he = A.div`
  min-height: 0px;
  overflow: auto;
`, at = A.div`
  &, .infinite-scroll-component__outerdiv {
    display: flex;
    flex-direction: column;

    min-height: 0px;
    flex: 1 1 auto;

    .infinite-scroll-component {
      min-height: 0px;
      flex: 1 1 auto;
    }
  }
`;
function N({ searchText: e, onSearchTextChange: t, extraControls: a, loading: o, items: i, renderItem: r }) {
  const { t: s } = P();
  return /* @__PURE__ */ p(me, { children: [
    /* @__PURE__ */ n(
      ee,
      {
        placeholder: s("misc.search"),
        searchText: e,
        onSearchTextChange: t
      }
    ),
    a && /* @__PURE__ */ n("div", { children: a }),
    /* @__PURE__ */ n(he, { children: /* @__PURE__ */ n(_, { spinning: o, children: /* @__PURE__ */ n(
      B,
      {
        dataSource: i,
        renderItem: r
      }
    ) }) })
  ] });
}
N.Container = me;
N.ListContainer = he;
N.InfiniteScrollListContainer = at;
const E = Ce(void 0);
function ot(e) {
  return /* @__PURE__ */ n(E.Provider, { value: e, children: e.children });
}
function it(e) {
  return [
    {
      value: "",
      label: e("agentStatus.all")
    },
    {
      value: "Idle",
      label: e("agentStatus.available")
    },
    {
      value: "Break",
      label: e("agentStatus.onBreak")
    },
    {
      value: "Busy PendingBreak PendingLogout",
      label: e("agentStatus.busy")
    }
  ];
}
function rt() {
  const { businessUnitId: e } = v(L), { agentsTab: t } = v(E);
  if (!t)
    throw new Error("Cannot render AgentsTab without the necessary properties.");
  const { actions: a } = t, { t: o } = P(), { data: i, isLoading: r, isFetching: s } = Ve(e, { pollingInterval: 10 * 1e3 }), [c, b] = g(""), [T] = q(c, 800), [m, f] = g(""), l = w(
    () => {
      let d = i ? [...i] : [];
      if (T) {
        const C = T.toLocaleLowerCase();
        d = d.filter((I) => {
          var h;
          return I.name.toLocaleLowerCase().includes(C) || I.email.toLocaleLowerCase().includes(C) || ((h = I.phone) == null ? void 0 : h.toLocaleLowerCase().includes(C));
        });
      }
      if (m) {
        const C = m.split(" ");
        d = d.filter((I) => C.includes(I.status));
      }
      return d.sort((C, I) => C.name.localeCompare(I.name, "en", { sensitivity: "base" }));
    },
    [i, T, m]
  ), u = V(
    (d) => f(d),
    []
  ), [k, S] = g(""), x = w(
    () => it(o),
    [o]
  );
  return /* @__PURE__ */ n(
    N,
    {
      searchText: c,
      onSearchTextChange: b,
      extraControls: /* @__PURE__ */ n(
        Be,
        {
          placeholder: o("agentStatus.busy"),
          options: x,
          defaultValue: "",
          onSelect: u,
          style: { width: 120 }
        }
      ),
      loading: r || s,
      items: l,
      renderItem: (d) => /* @__PURE__ */ n(
        J,
        {
          active: k === d.id,
          onActivate: () => S(k === d.id ? "" : d.id),
          title: d.name,
          description: /* @__PURE__ */ n(st, { agent: d }),
          status: d.status,
          actions: typeof a == "function" ? a(d) : a
        },
        d.id
      )
    }
  );
}
function st({ agent: e }) {
  const { t } = P();
  return /* @__PURE__ */ p(Y, { children: [
    /* @__PURE__ */ n($, { title: e.email, children: /* @__PURE__ */ p("span", { className: "df-detail", "aria-label": t("persona.contactEmailAddress"), children: [
      /* @__PURE__ */ n(Z, {}),
      " ",
      e.email ?? t("misc.n/a")
    ] }) }),
    " ".repeat(4),
    /* @__PURE__ */ n($, { title: e.phone, children: /* @__PURE__ */ p("span", { className: "df-detail", "aria-label": t("persona.contactPhoneNumber"), children: [
      /* @__PURE__ */ n(X, {}),
      " ",
      e.phone ?? t("misc.n/a")
    ] }) })
  ] });
}
const F = O({
  reducerPath: "emailConnector",
  tagTypes: [],
  baseQuery: z(""),
  endpoints: (e) => ({
    listEmailChannels: e.query({
      query: () => "/channel-providers/graph-email/configurations"
    })
  })
}), {
  useListEmailChannelsQuery: ct
} = F, j = O({
  reducerPath: "sipConnector",
  tagTypes: [],
  baseQuery: z("/sipconnector"),
  endpoints: (e) => ({
    listVoiceChannels: e.query({
      query: () => "/channel-providers/voice/configurations"
    })
  })
}), {
  useListVoiceChannelsQuery: lt
} = j;
function ut(e) {
  return {
    id: e.id,
    name: e.name,
    identifier: e.phoneNumber ?? "",
    isDefault: e.isDefault,
    businessUnitId: e.businessUnitId
  };
}
function dt(e) {
  return {
    id: Number.parseInt(e.channelId, 10),
    name: e.channelName,
    identifier: e.defaultUser,
    isDefault: e.isDefault,
    businessUnitId: e.businessUnitId
  };
}
function mt(e, t) {
  const { data: a, isLoading: o, isFetching: i } = ct(void 0, { skip: e !== "email" }), { data: r, isLoading: s, isFetching: c } = lt(void 0, { skip: e !== "voice" });
  return { channels: w(
    () => {
      let m;
      switch (e) {
        case "chat":
          throw new Error(`Unsupported media group ${e}`);
        case "email":
          m = (a == null ? void 0 : a.map(dt)) ?? [];
          break;
        case "voice":
          m = (r == null ? void 0 : r.map(ut)) ?? [];
          break;
      }
      return m.filter((f) => f.businessUnitId === t);
    },
    [t, a, e, r]
  ), isLoading: o || i || s || c };
}
const ht = W.div`
  font-size: ${(e) => e.theme.controlHeight}px;
  color: ${(e) => e.theme.colorTextTertiary};
`;
function be({ icon: e, ...t }) {
  return /* @__PURE__ */ n(
    de,
    {
      ...t,
      avatar: /* @__PURE__ */ n(ht, { children: e })
    }
  );
}
function bt() {
  const { businessUnitId: e } = v(L), { channelsTab: t, mediaGroup: a } = v(E);
  if (!t)
    throw new Error("Cannot render ChannelsTab without the necessary properties.");
  const { actions: o } = t, { channels: i, isLoading: r } = mt(a, e), [s, c] = g(""), [b] = q(s, 800), T = w(
    () => {
      if (i) {
        const l = b.toLocaleLowerCase();
        return i.filter((u) => u.name.toLocaleLowerCase().includes(l)).sort((u, k) => u.name.localeCompare(k.name, "en", { sensitivity: "base" }));
      }
      return [];
    },
    [i, b]
  ), [m, f] = g(0);
  return /* @__PURE__ */ n(
    N,
    {
      searchText: s,
      onSearchTextChange: c,
      loading: r,
      items: T,
      renderItem: (l) => /* @__PURE__ */ n(
        be,
        {
          active: m === l.id,
          onActivate: () => f(m === l.id ? 0 : l.id),
          title: l.name,
          description: l.identifier,
          icon: _e(a),
          actions: typeof o == "function" ? o(l) : o
        },
        l.id
      )
    }
  );
}
var D = /* @__PURE__ */ ((e) => (e.Equals = "Equals", e.Contains = "Contains", e.NotEquals = "NotEquals", e))(D || {});
const U = 50, M = O({
  reducerPath: "directory",
  tagTypes: [],
  baseQuery: z("/directory"),
  endpoints: (e) => ({
    searchExternalContacts: e.query({
      query: (t) => {
        const a = [`top=${U}`];
        return t.term && a.push(`term=${t.term}`), t.skipToken && a.push(`skipToken=${t.skipToken}`), `/externalContacts/?${a.join("&")}`;
      }
    }),
    getContacts: e.mutation({
      query: ({ contactDirectoryId: t, query: a }) => ({
        url: `/contactdirectories/${t}/contacts/query`,
        method: "POST",
        body: a
      })
    })
  })
}), {
  useSearchExternalContactsQuery: xn,
  useGetContactsMutation: pt
} = M, re = (e, t) => {
  const a = [];
  return t ? (a.push({ propertyName: "EmailAddress", operator: D.Contains, value: t }), a.push({ propertyName: "FullName", operator: D.Contains, value: t }), a.push({ propertyName: "PhoneNumber", operator: D.Contains, value: t })) : e === "voice" ? a.push({ propertyName: "PhoneNumber", operator: D.NotEquals, value: null }) : e === "email" && a.push({ propertyName: "EmailAddress", operator: D.NotEquals, value: null }), a;
}, gt = () => {
  var te;
  const { contactDirectoryTab: e, mediaGroup: t } = v(E), o = (te = v(L).agentWorkspace) == null ? void 0 : te.contactDirectoryId;
  if (!e || !o)
    throw new Error("Cannot render ContactDirectoryTab without the necessary properties.");
  const { actions: i } = e, { token: r } = G.useToken(), { t: s } = P(), [c, { data: b, isLoading: T }] = pt(), [m, f] = g([]), [l, u] = g(0), [k, S] = g(""), [x] = q(k, 800), [d, C] = g(0);
  R(
    () => {
      f([]), u(0), C(0);
      const y = {
        skip: 0,
        top: U,
        filters: re(t, x),
        orderBy: { ascending: !0, propertyName: "FullName" }
      };
      c({ contactDirectoryId: o, query: y });
    },
    [x, c, o, t]
  ), R(
    () => {
      b && (C(b.total), f((y) => [...y, ...b.results]));
    },
    [b]
  );
  const I = V(
    () => {
      const y = l + U;
      u(y);
      const ge = {
        skip: y,
        top: U,
        filters: re(t, x),
        orderBy: { ascending: !0, propertyName: "FullName" }
      };
      c({ contactDirectoryId: o, query: ge });
    },
    [o, x, c, t, l]
  ), [h, pe] = g("");
  return /* @__PURE__ */ p(N.Container, { children: [
    /* @__PURE__ */ n(
      ee,
      {
        placeholder: s("misc.search"),
        searchText: k,
        onSearchTextChange: S,
        loading: T
      }
    ),
    /* @__PURE__ */ n(N.InfiniteScrollListContainer, { children: /* @__PURE__ */ n(
      ue,
      {
        dataLength: m.length,
        next: I,
        hasMore: m.length !== d,
        loader: /* @__PURE__ */ n(_, { children: /* @__PURE__ */ n("div", { style: { height: r.controlHeight } }) }),
        endMessage: /* @__PURE__ */ n(le, { plain: !0, children: s("contactDirectoryTab.noMoreContacts") }),
        height: "100%",
        children: /* @__PURE__ */ n(
          B,
          {
            dataSource: m,
            renderItem: (y) => /* @__PURE__ */ n(
              J,
              {
                status: null,
                active: h === y.id,
                onActivate: () => pe(h === y.id ? "" : y.id),
                title: y.fullName,
                description: /* @__PURE__ */ n(ft, { contact: y }),
                actions: typeof i == "function" ? i(y) : i
              },
              y.id
            )
          }
        )
      }
    ) })
  ] });
}, ft = ({ contact: e }) => {
  const { t } = P();
  return /* @__PURE__ */ p(Y, { children: [
    /* @__PURE__ */ n($, { title: e.emailAddress ?? t("misc.n/a"), children: /* @__PURE__ */ p("span", { className: "df-detail", "aria-label": t("persona.contactEmailAddress"), children: [
      /* @__PURE__ */ n(Z, {}),
      " ",
      e.emailAddress ?? t("misc.n/a")
    ] }) }),
    " ".repeat(4),
    /* @__PURE__ */ n($, { title: e.phoneNumber ?? t("misc.n/a"), children: /* @__PURE__ */ p("span", { className: "df-detail", "aria-label": t("persona.contactPhoneNumber"), children: [
      /* @__PURE__ */ n(X, {}),
      " ",
      e.phoneNumber ?? t("misc.n/a")
    ] }) })
  ] });
};
function yt() {
  const { internalContactsTab: e } = v(E);
  if (!e)
    throw new Error("Cannot render ExternalContactsTab without the necessary properties.");
  const { actions: t } = e, { token: a } = G.useToken(), { t: o } = P(), [i, r] = g(""), [s] = q(i, 800), [c, b] = g(""), [T, m] = g(0), [f, { data: l, isLoading: u, isFetching: k }] = M.useLazySearchExternalContactsQuery(), [S, x] = g([]);
  R(
    () => {
      b(""), x([]), m(0), f({ term: s, skipToken: "" });
    },
    [s, f]
  ), R(
    () => {
      l && (b(l.skipToken), m((h) => l.totalCount ?? h), x((h) => [...h, ...l.results]));
    },
    [l]
  );
  const d = V(
    () => f({ term: s, skipToken: c }),
    [s, f, c]
  ), [C, I] = g("");
  return /* @__PURE__ */ p(N.Container, { children: [
    /* @__PURE__ */ n(
      ee,
      {
        placeholder: o("misc.search"),
        searchText: i,
        onSearchTextChange: r,
        loading: u || k
      }
    ),
    /* @__PURE__ */ n(N.InfiniteScrollListContainer, { children: /* @__PURE__ */ n(
      ue,
      {
        dataLength: S.length,
        next: d,
        hasMore: S.length !== T,
        loader: /* @__PURE__ */ n(_, { children: /* @__PURE__ */ n("div", { style: { height: a.controlHeight } }) }),
        endMessage: /* @__PURE__ */ n(le, { plain: !0, children: o("externalContactsTab.noMoreContacts") }),
        height: "100%",
        children: /* @__PURE__ */ n(
          B,
          {
            dataSource: S,
            renderItem: (h) => /* @__PURE__ */ n(
              J,
              {
                active: C === h.id,
                onActivate: () => I(C === h.id ? "" : h.id),
                title: h.name,
                description: /* @__PURE__ */ n(Tt, { externalContact: h }),
                status: h.status,
                actions: typeof t == "function" ? t(h) : t
              },
              h.id
            )
          }
        )
      }
    ) })
  ] });
}
function Tt({ externalContact: e }) {
  const { t } = P(), a = w(
    () => {
      var i;
      return (i = e.phones) == null ? void 0 : i.find((r) => r.type === "Mobile");
    },
    [e.phones]
  ), o = w(
    () => {
      var i;
      return (i = e.phones) == null ? void 0 : i.find((r) => r.type === "Business");
    },
    [e.phones]
  );
  return /* @__PURE__ */ p(Y, { children: [
    /* @__PURE__ */ n($, { title: e.email, children: /* @__PURE__ */ p("span", { className: "df-detail", "aria-label": t("persona.contactEmailAddress"), children: [
      /* @__PURE__ */ n(Z, {}),
      " ",
      e.email ?? t("misc.n/a")
    ] }) }),
    " ".repeat(4),
    a || o ? /* @__PURE__ */ p(ye, { children: [
      o && /* @__PURE__ */ n($, { title: o.value, children: /* @__PURE__ */ p("span", { className: "df-detail", "aria-label": t("persona.contactPhoneNumber"), children: [
        /* @__PURE__ */ n(X, {}),
        " ",
        o.value
      ] }) }),
      " ".repeat(4),
      a && a.value !== (o == null ? void 0 : o.value) && /* @__PURE__ */ n($, { title: a.value, children: /* @__PURE__ */ p("span", { className: "df-detail", "aria-label": t("persona.contactMobileNumber"), children: [
        /* @__PURE__ */ n(Me, {}),
        " ",
        a.value
      ] }) })
    ] }) : /* @__PURE__ */ p("span", { className: "df-detail", "aria-label": t("persona.contactPhoneNumber"), children: [
      /* @__PURE__ */ n(X, {}),
      " ",
      t("misc.n/a")
    ] })
  ] });
}
const H = O({
  reducerPath: "workflow",
  tagTypes: [],
  baseQuery: z("/workflow"),
  endpoints: (e) => ({
    listAvailableQueuesForConversation: e.query({
      query: (t) => `/conversations/${t}/queues`
    })
  })
}), {
  useListAvailableQueuesForConversationQuery: Ct
} = H;
function kt(e) {
  return (t, a) => t.id === e ? -1 : a.id === e ? 1 : 0;
}
function vt() {
  const { queuesTab: e } = v(E);
  if (!e)
    throw new Error("Cannot render QueuesTab without the necessary properties.");
  const { actions: t, conversationId: a, sourceQueueId: o } = e, { t: i } = P(), { data: r, isLoading: s } = Ct(a, { skip: !a }), [c, b] = g(""), [T] = q(c, 800), m = w(
    () => {
      if (r) {
        const u = T.toLocaleLowerCase(), k = r.filter((S) => S.name.toLocaleLowerCase().includes(u)).sort((S, x) => S.name.localeCompare(x.name, "en", { sensitivity: "base" }));
        return o && k.sort(kt(o)), k;
      }
      return [];
    },
    [T, r, o]
  ), [f, l] = g("");
  return /* @__PURE__ */ n(
    N,
    {
      searchText: c,
      onSearchTextChange: b,
      loading: s,
      items: m,
      renderItem: (u) => /* @__PURE__ */ n(
        be,
        {
          active: f === u.id,
          onActivate: () => l(f === u.id ? "" : u.id),
          title: /* @__PURE__ */ p(xe, { size: "small", children: [
            u.name,
            " ",
            u.id === o && /* @__PURE__ */ n(Ie, { color: "success", children: i("queuesTab.sourceQueue") })
          ] }),
          description: void 0,
          icon: /* @__PURE__ */ n(Le, {}),
          actions: typeof t == "function" ? t(u) : t
        },
        u.id
      )
    }
  );
}
const St = A(we)`
  max-height: 100%;

  .ant-tabs-content-holder {
    display: flex;
    flex-direction: column;

    .ant-tabs-content {
      min-height: 1px;
      display: flex;
      flex-direction: column;

      .ant-tabs-tabpane {
        min-height: 1px;

        &.ant-tabs-tabpane-active {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
`;
function xt(e) {
  const { agentWorkspace: t } = v(L), { t: a } = P(), o = w(
    () => {
      const i = [];
      return e.agentsTab && i.push({
        key: "agents",
        label: a("agentsTab.title"),
        children: /* @__PURE__ */ n(rt, {})
      }), e.channelsTab && i.push({
        key: "channels",
        label: a("channelsTab.title"),
        children: /* @__PURE__ */ n(bt, {})
      }), e.queuesTab && i.push({
        key: "queues",
        label: a("queuesTab.title"),
        children: /* @__PURE__ */ n(vt, {})
      }), e.internalContactsTab && i.push({
        key: "external-contacts",
        label: a("externalContactsTab.title"),
        children: /* @__PURE__ */ n(yt, {})
      }), e.contactDirectoryTab && (t != null && t.contactDirectoryId) && i.push({
        key: "contact-directory",
        label: a("contactDirectoryTab.title"),
        children: /* @__PURE__ */ n(gt, {})
      }), e.extraTabs ? i.concat(e.extraTabs.map((r, s) => ({ ...r, key: `extraTab-${s}` }))) : i;
    },
    [t == null ? void 0 : t.contactDirectoryId, e.agentsTab, e.channelsTab, e.contactDirectoryTab, e.extraTabs, e.internalContactsTab, e.queuesTab, a]
  );
  return /* @__PURE__ */ n(He, { children: /* @__PURE__ */ n(
    St,
    {
      items: o,
      animated: !0
    }
  ) });
}
const It = (e, t) => ze({
  reducer: {
    [Q.name]: Q.reducer,
    [K.reducerPath]: K.reducer,
    [M.reducerPath]: M.reducer,
    [F.reducerPath]: F.reducer,
    [j.reducerPath]: j.reducer,
    [H.reducerPath]: H.reducer
  },
  middleware: (o) => o().concat(
    K.middleware,
    M.middleware,
    F.middleware,
    j.middleware,
    H.middleware
  ),
  preloadedState: {
    [Q.name]: {
      apiBaseUrl: e,
      token: t,
      agentId: je(t).sub
    }
  }
}), wt = "./schema.json", Nt = {
  misc: {
    "n/a": "n/a",
    search: "Suche"
  },
  persona: {
    profilePicture: "Profilbild",
    contactEmailAddress: "E-Mail-Adresse",
    contactPhoneNumber: "Telefonnummer",
    contactMobileNumber: "Handynummer"
  },
  agentStatus: {
    all: "Alle",
    available: "Verfügbar",
    onBreak: "In Pause",
    busy: "Beschäftigt",
    loggedOut: "Ausgeloggt",
    unknown: "Unbekannt"
  },
  agentsTab: {
    title: "Agenten",
    status: "Status"
  },
  channelsTab: {
    title: "Kanäle"
  },
  externalContactsTab: {
    title: "Interne Kontakte",
    noMoreContacts: "Keine weiteren Kontakte gefunden"
  },
  queuesTab: {
    title: "Warteschlangen",
    sourceQueue: "Ursprungswarteschlange"
  },
  contactDirectoryTab: {
    title: "Kontaktverzeichnis",
    noMoreContacts: "Keine weiteren Kontakte gefunden"
  }
}, Pt = {
  $schema: wt,
  translation: Nt
}, $t = {
  misc: {
    "n/a": "n/a",
    search: "Search"
  },
  persona: {
    profilePicture: "Profile picture",
    contactEmailAddress: "Contact email address",
    contactPhoneNumber: "Contact phone number",
    contactMobileNumber: "Contact mobile number"
  },
  agentStatus: {
    all: "All",
    available: "Available",
    onBreak: "On break",
    busy: "Busy",
    loggedOut: "Logged out",
    unknown: "Unknown"
  },
  agentsTab: {
    title: "Agents",
    status: "Status"
  },
  channelsTab: {
    title: "Channels"
  },
  externalContactsTab: {
    title: "Internal contacts",
    noMoreContacts: "No more contacts found"
  },
  queuesTab: {
    title: "Queues",
    sourceQueue: "Source Queue"
  },
  contactDirectoryTab: {
    title: "Contact Directory",
    noMoreContacts: "No more contacts found"
  }
}, At = {
  translation: $t
}, Dt = "./schema.json", Et = {
  misc: {
    "n/a": "N/A",
    search: "buscar"
  },
  persona: {
    profilePicture: "foro de perfil",
    contactEmailAddress: "correo electronico de contacto",
    contactPhoneNumber: "telefono de contacto",
    contactMobileNumber: "numero de movil de contacto"
  },
  agentStatus: {
    all: "Todos",
    available: "Disponible",
    onBreak: "En descanso",
    busy: "Ocupado",
    loggedOut: "Desconectado",
    unknown: "Desconocido"
  },
  agentsTab: {
    title: "Agentes",
    status: "Estado"
  },
  channelsTab: {
    title: "Canales"
  },
  externalContactsTab: {
    title: "Contactos internos",
    noMoreContacts: "No se encontraron más contactos"
  },
  queuesTab: {
    title: "Colas",
    sourceQueue: "Cola de origen"
  },
  contactDirectoryTab: {
    title: "Directorio de contactos",
    noMoreContacts: "No se encontraron más contactos"
  }
}, Mt = {
  $schema: Dt,
  translation: Et
}, Lt = "./schema.json", Bt = {
  misc: {
    "n/a": "n/a",
    search: "recherche"
  },
  persona: {
    profilePicture: "image de profil",
    contactEmailAddress: "adresse email de contact",
    contactPhoneNumber: "numero de telephone de contact",
    contactMobileNumber: "numero de portable de contact"
  },
  agentStatus: {
    all: "Tous",
    available: "Disponible",
    onBreak: "En pause",
    busy: "Occupé",
    loggedOut: "Déconnecté",
    unknown: "Inconnu"
  },
  agentsTab: {
    title: "Agents",
    status: "Statut"
  },
  channelsTab: {
    title: "Canaux"
  },
  externalContactsTab: {
    title: "Contacts internes",
    noMoreContacts: "Plus de contacts trouvés"
  },
  queuesTab: {
    title: "Files d'attente",
    sourceQueue: "File d'attente source"
  },
  contactDirectoryTab: {
    title: "Annuaire de contacts",
    noMoreContacts: "Plus de contacts trouvés"
  }
}, qt = {
  $schema: Lt,
  translation: Bt
}, Ot = "./schema.json", zt = {
  misc: {
    "n/a": "n/a",
    search: "Keresés"
  },
  persona: {
    profilePicture: "Profil kép",
    contactEmailAddress: "Kontakt e-mail címe",
    contactPhoneNumber: "Kontakt telefonszáma",
    contactMobileNumber: "Kontakt mobilszáma"
  },
  agentStatus: {
    all: "Mind",
    available: "Elérhető",
    onBreak: "Szüneten",
    busy: "Elfoglalt",
    loggedOut: "Kijelentkezett",
    unknown: "Ismeretlen"
  },
  agentsTab: {
    title: "Ügynökök",
    status: "Státusz"
  },
  channelsTab: {
    title: "Csatornák"
  },
  externalContactsTab: {
    title: "Belső kontaktok",
    noMoreContacts: "Nem található több kontakt"
  },
  queuesTab: {
    title: "Várólisták",
    sourceQueue: "Eredeti Várólista"
  },
  contactDirectoryTab: {
    title: "Kapcsolatok",
    noMoreContacts: "Nem található több kapcsolat"
  }
}, Qt = {
  $schema: Ot,
  translation: zt
}, Kt = "./schema.json", Ft = {
  misc: {
    "n/a": "n/a",
    search: "ricerca"
  },
  persona: {
    profilePicture: "immagine del profilo",
    contactEmailAddress: "indirizzo email di contatto",
    contactPhoneNumber: "numero di contatto telefonico",
    contactMobileNumber: "contatta il numero cellulare"
  },
  agentStatus: {
    all: "Tutti",
    available: "Disponibile",
    onBreak: "In pausa",
    busy: "Occupato",
    loggedOut: "Disconnesso",
    unknown: "Sconosciuto"
  },
  agentsTab: {
    title: "Agenti",
    status: "Stato"
  },
  channelsTab: {
    title: "Canali"
  },
  externalContactsTab: {
    title: "Contatti interni",
    noMoreContacts: "Nessun altro contatto trovato"
  },
  queuesTab: {
    title: "Code",
    sourceQueue: "Coda di origine"
  },
  contactDirectoryTab: {
    title: "Elenco contatti",
    noMoreContacts: "Nessun altro contatto trovato"
  }
}, jt = {
  $schema: Kt,
  translation: Ft
}, Ut = "./schema.json", Ht = {
  misc: {
    "n/a": "n.v.t",
    search: "zoekopdracht"
  },
  persona: {
    profilePicture: "profielfoto",
    contactEmailAddress: "contact email adres",
    contactPhoneNumber: "contact telefoonnummer",
    contactMobileNumber: "contact mobiel nummer"
  },
  agentStatus: {
    all: "Allemaal",
    available: "Beschikbaar",
    onBreak: "In pauze",
    busy: "Bezet",
    loggedOut: "Uitgelogd",
    unknown: "Onbekend"
  },
  agentsTab: {
    title: "Agenten",
    status: "Status"
  },
  channelsTab: {
    title: "Kanalen"
  },
  externalContactsTab: {
    title: "Interne contacten",
    noMoreContacts: "Geen andere contacten gevonden"
  },
  queuesTab: {
    title: "Wachtrijen",
    sourceQueue: "Bronwachtrij"
  },
  contactDirectoryTab: {
    title: "Contacten Directory",
    noMoreContacts: "Geen andere contacten gevonden"
  }
}, Rt = {
  $schema: Ut,
  translation: Ht
}, Xt = "./schema.json", Vt = {
  misc: {
    "n/a": "Neaplicabil",
    search: "Caută"
  },
  persona: {
    profilePicture: "Poza de profil",
    contactEmailAddress: "Adresa e-mail de contact",
    contactPhoneNumber: "Nr telefon de contact",
    contactMobileNumber: "Nr mobil de contact"
  },
  agentStatus: {
    all: "Toți",
    available: "Disponibili",
    onBreak: "În pauză",
    busy: "Ocupați",
    loggedOut: "Deconectați",
    unknown: "Status necunoscut"
  },
  agentsTab: {
    title: "Agenți",
    status: "Status"
  },
  channelsTab: {
    title: "Canale"
  },
  externalContactsTab: {
    title: "Contacte interne",
    noMoreContacts: "Nu au fost gasite contacte"
  },
  queuesTab: {
    title: "Cozi",
    sourceQueue: "Coadă sursă"
  },
  contactDirectoryTab: {
    title: "Director de contacte",
    noMoreContacts: "Nu au fost gasite contacte"
  }
}, Wt = {
  $schema: Xt,
  translation: Vt
}, _t = "./schema.json", Gt = {
  misc: {
    "n/a": "geçerli değil",
    search: "Ara"
  },
  persona: {
    profilePicture: "Profil resmi",
    contactEmailAddress: "İletişim e-posta adresi",
    contactPhoneNumber: "İletişim telefon numarası",
    contactMobileNumber: "İletişim cep numarası"
  },
  agentStatus: {
    all: "Hepsi",
    available: "Mevcut",
    onBreak: "Molada",
    busy: "Meşgul",
    loggedOut: "Çıkış yaptı",
    unknown: "Bilinmiyor"
  },
  agentsTab: {
    title: "MHTleri",
    status: "Durum"
  },
  channelsTab: {
    title: "Kanallar"
  },
  externalContactsTab: {
    title: "Dahili kişiler",
    noMoreContacts: "Başka kişi bulunamadı"
  },
  queuesTab: {
    title: "Kuyruklar",
    sourceQueue: "Kaynak Kuyruk"
  },
  contactDirectoryTab: {
    title: "İletişim Dizini",
    noMoreContacts: "Başka kişi bulunamadı"
  }
}, Zt = {
  $schema: _t,
  translation: Gt
}, Jt = {
  misc: {
    "n/a": "n/d",
    search: "Pretraži"
  },
  persona: {
    profilePicture: "Profilna slika",
    contactEmailAddress: "Kontakt e-mail adresa",
    contactPhoneNumber: "Kontakt telefon",
    contactMobileNumber: "Kontakt mobilni broj"
  },
  agentStatus: {
    all: "Svi",
    available: "Dostupan",
    onBreak: "Na pauzi",
    busy: "Zauzet",
    loggedOut: "Odjavljen",
    unknown: "Nepoznato"
  },
  agentsTab: {
    title: "Agenti",
    status: "Status"
  },
  channelsTab: {
    title: "Kanali"
  },
  externalContactsTab: {
    title: "Interni kontakti",
    noMoreContacts: "Nema više pronađenih kontakata"
  },
  queuesTab: {
    title: "Redovi",
    sourceQueue: "Izvorni red"
  },
  contactDirectoryTab: {
    title: "Imenik kontakata",
    noMoreContacts: "Nema više pronađenih kontakata"
  }
}, Yt = {
  translation: Jt
}, en = {
  misc: {
    "n/a": "n/d",
    search: "Pretraga"
  },
  persona: {
    profilePicture: "Profilna slika",
    contactEmailAddress: "Kontakt imejl adresa",
    contactPhoneNumber: "Kontakt telefon",
    contactMobileNumber: "Kontakt mobilni broj"
  },
  agentStatus: {
    all: "Svi",
    available: "Dostupan",
    onBreak: "Na pauzi",
    busy: "Zauzet",
    loggedOut: "Odjavljen",
    unknown: "Nepoznato"
  },
  agentsTab: {
    title: "Agenti",
    status: "Status"
  },
  channelsTab: {
    title: "Kanali"
  },
  externalContactsTab: {
    title: "Interni kontakti",
    noMoreContacts: "Nema više pronađenih kontakata"
  },
  queuesTab: {
    title: "Redovi",
    sourceQueue: "Izvorni red"
  },
  contactDirectoryTab: {
    title: "Imenik kontakata",
    noMoreContacts: "Nema više pronađenih kontakata"
  }
}, tn = {
  translation: en
}, nn = {
  "en-US": At,
  "hu-HU": Qt,
  "ro-RO": Wt,
  "de-DE": Pt,
  "es-ES": Mt,
  "fr-FR": qt,
  "it-IT": jt,
  "nl-NL": Rt,
  "tr-TR": Zt,
  "hr-HR": Yt,
  "sr-RS": tn
};
function an({ children: e, theme: t }) {
  return /* @__PURE__ */ n(Ne, { theme: t, children: /* @__PURE__ */ n(on, { children: e }) });
}
function on({ children: e }) {
  const { token: t } = G.useToken();
  return /* @__PURE__ */ n(ve, { theme: t, children: e });
}
function rn(e) {
  const { apiBaseUrl: t, token: a, language: o, theme: i } = v(se), r = w(
    () => It(t, a),
    [t, a]
  ), s = w(
    () => {
      const c = Ke.createInstance();
      return c.use(Pe).init({
        resources: nn,
        lng: o,
        fallbackLng: "en-US",
        interpolation: {
          escapeValue: !1
        }
      }), c;
    },
    [o]
  );
  return /* @__PURE__ */ n(Fe, { store: r, children: /* @__PURE__ */ n(an, { theme: i, children: /* @__PURE__ */ n(ot, { ...e, children: /* @__PURE__ */ n($e, { i18n: s, children: e.children }) }) }) });
}
const sn = A.div`
  height: 100%;
`;
function In(e) {
  const t = v(se), a = v(L);
  if (!t || !a)
    throw new Error("DirectoryFragment must be rendered within a HostContext and WorkItemContext");
  return /* @__PURE__ */ n(sn, { id: "buzzeasy-fragment-directory", role: "region", children: /* @__PURE__ */ n(rn, { ...e, children: /* @__PURE__ */ n(xt, { ...e }) }) });
}
fe("directory-fragment", "20250124.2", "1.3.2");
export {
  In as default
};
//# sourceMappingURL=index.js.map
